import { useGetOne } from 'react-admin';

export function useWellnessProducts() {
  return useGetOne('wellness', { id: 'wellness-products' });
}
